<div class="logo-container">
	<img class="img" src="/assets/img/dropbox-sign-plus-procore.jpg" />
</div>

<div class="loading-container" *ngIf="loading">
	<div class="lds-facebook">
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>

<!-- SCREEN 2.1A -->
<div [ngClass]="{'hidden': loading }">
	<div class="wizard-title">TRIAL SETUP</div>
	<form #f="ngForm" [formGroup]="form">
		<div class="form-container">
			<div class="form-text-container">Do you already have a Dropbox Sign account?</div>
			<select #selectAccountType formControlName="accountType" id="accountType" (change)="changeAccountType($event)" class="valid">
				<option value="shared" [selected]="true">No, provide an account</option>
				<option value="connector">Yes, use my account</option>
			</select>

			<div class="form-text-container">Will each requester send signature requests as an individual Dropbox Sign user, or will all requesters use a single shared "system" user?​</div>
			<select #selectUsersType formControlName="usersType" id="usersType" (change)="changeUsersType($event)" class="valid">
				<option value="OAUTH">Individual users (recommended)</option>
				<option value="OAUTHG">One system user</option>
			</select>

			<div [ngClass]="{'hidden': accountType !== 'shared' }">
				<div class="form-text-container">Enter an e-mail address to invite your subscription admin to the trial Dropbox Sign team. You will need access to this email to accept the invitation.​</div>
				<input #inputEmail formControlName="email" [ngClass]="{'valid': emailValid == true, 'invalid': emailValid == false}" (keyup)="doEmailValidation($event)" (change)="doEmailValidation($event)" />
				<div *ngIf="errorEmailAddress" class="error-message">This e-mail is associated with an existing Dropbox Sign team. Either provide a different email address or delete it from the existing team.</div>
			</div>

			<div [ngClass]="{'hidden': accountType !== 'connector' }">
				<div class="form-text-container"><a href="https://procore-dbs.shakeit.ai/docs/setup-guide/configure-dropbox-sign" target="_blank">Create an API Key and client app</a> in Dropbox Sign and enter the following information:</div>
				<div class="form-text-container label">Dropbox Sign Client ID:</div>
				<input #inputClientId formControlName="clientId" [ngClass]="{'valid': clientIdValid == true, 'invalid': clientIdValid == false}" (change)="doClientIdValidation($event)" />
				<div class="form-text-container label">Dropbox Sign OAuth Secret:</div>
				<input #inputOauthSecret formControlName="oauthSecret" [ngClass]="{'valid': oauthSecretValid == true, 'invalid': oauthSecretValid == false }" (change)="doOauthSecretValidation($event)" />
				<div class="form-text-container label">Dropbox Sign API Key:</div>
				<input #inputApiKey formControlName="apiKey" [ngClass]="{'valid': apiKeyValid == true, 'invalid': apiKeyValid == false }" (change)="doApiKeyValidation($event)" />
			</div>
			<button (click)="selectTrialContinue()" [disabled]="!form.valid">Continue</button>
			<button class="secondary" (click)="selectBack()">Back</button>
		</div>
	</form>
</div>